import React from "react";
import PageHero from "@/components/sections/PageHero";
import CTABanner from "@/components/sections/CTABanner";
import SEO from "@/components/SEO";

const CATEGORIES = [
    { name: "Instruments", count: "Guitars · Keyboards · Drums" },
    { name: "Accessories", count: "Cables · Stands · Picks" },
    { name: "Learning Materials", count: "Books · Sheet music · Courses" },
];

export default function Store() {
    return (
        <div data-testid="page-store">
            <SEO
                title="Store (Coming Soon) | Ihao Music House Delhi"
                description="The Ihao Music House Delhi store — instruments, accessories and learning materials — is coming soon. Meanwhile, WhatsApp us for curated recommendations."
                path="/shop"
            />
            <PageHero
                eyebrow="Store"
                title="Ihao Shop — Coming Soon."
                subtitle="We're curating a collection of instruments, accessories and learning materials for our community. In the meantime, ping us on WhatsApp for personalised recommendations."
            />

            <section className="relative py-20 md:py-28 bg-background">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {CATEGORIES.map((c, i) => (
                            <div key={c.name} data-testid={`store-category-${i}`} className="relative rounded-2xl border border-white/10 bg-[#121212] p-8 hover:border-gold/40 transition-colors overflow-hidden">
                                <div className="absolute inset-0 bg-radial-gold opacity-20" />
                                <div className="relative">
                                    <span className="text-gold font-display text-5xl font-light">{String(i + 1).padStart(2, "0")}</span>
                                    <h3 className="mt-4 font-display text-2xl text-white font-semibold">{c.name}</h3>
                                    <p className="mt-2 text-sm text-white/55">{c.count}</p>
                                    <span className="mt-6 inline-block text-[10px] tracking-[0.3em] uppercase text-gold border border-gold/30 rounded-full px-3 py-1">Coming Soon</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="mt-16 text-center">
                        <p className="text-white/60">
                            Need something right now?
                        </p>
                        <a
                            href="https://wa.me/918800747721"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="store-whatsapp-btn"
                            className="mt-5 inline-flex items-center justify-center bg-gold text-black font-semibold text-sm px-8 py-4 rounded-full hover:scale-[1.03] hover:bg-gold-hover transition-all duration-300 gold-glow"
                        >
                            Enquire on WhatsApp
                        </a>
                    </div>
                </div>
            </section>

            <CTABanner title="Want curated gear advice?" subtitle="Book a free consultation with our faculty — we'll help you pick the right instrument for your level and budget." />
        </div>
    );
}
